import React, {FC} from 'react';
import styled, {useTheme} from 'styled-components';

import {Trans} from '../../../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {IconButton} from '../../../../../../../../libs/shared/ui/src/components/buttons/iconButton';
import {useClipboard} from '../../../../../../../../libs/shared/ui/src/hooks/clipboardHookHelpers';

interface AnnotationViewerReferencePreviewCopyButtonProps {
  value: string;
  shouldShowCheckmark: boolean;
  setShouldShowCheckmark: (shouldShowCheckmark: boolean) => void;
}

export const StyledCopyIconWrapper = styled.div`
  display: none;

  position: absolute;
  align-items: center;
  height: 26px;
  width: 26px;
  right: 1px;
  overflow: hidden;
  background: ${(p) =>
    `linear-gradient(90deg, ${p.theme.alphas.white10} 5%, ${p.theme.alphas.white50} 15%, ${p.theme.greys.white} 40%)`};
`;

const StyledIconDiv = styled.div`
  position: absolute;
`;

const StyledWrapper = styled.div``;

export const AnnotationViewerReferencePreviewCopyButton: FC<
  AnnotationViewerReferencePreviewCopyButtonProps
> = (props) => {
  const theme = useTheme();
  const {copy} = useClipboard();

  return (
    <StyledWrapper>
      <StyledCopyIconWrapper>
        <StyledIconDiv>
          {props.shouldShowCheckmark ? (
            <IconButton
              iconName="checkmarkBoxSmall"
              color={theme.palette.green.shade40}
              label={<Trans id="annotation-customfield-copybutton">Copied</Trans>}
              backgroundHoverColor={theme.greys.white}
              hoverActiveColor={theme.palette.green.shade40}
              hoverColor={theme.palette.green.shade40}
            />
          ) : (
            <IconButton
              iconName="copySmall"
              color={theme.greys.shade70}
              label={<Trans id="annotation-customfield-copybutton">Copy</Trans>}
              onClick={(clickEvent) => {
                clickEvent.preventDefault();
                copy(props.value);
                props.setShouldShowCheckmark(true);
              }}
            />
          )}
        </StyledIconDiv>
      </StyledCopyIconWrapper>
    </StyledWrapper>
  );
};
